import React from "react";

import ListGroup from "react-bootstrap/ListGroup";
import Image from "react-bootstrap/Image";

import { FiMenu, FiX } from "react-icons/fi";
import { FaHome, FaUserCircle } from 'react-icons/fa';
import { BiCabinet } from "react-icons/bi"
import logo from "../images/logo.png";

import { Redirect } from "react-router";
import { Link } from "react-router-dom";


import "../css/style.css";



export default class SideNavContainer extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      hideNavbar: false, //blocks user from using the 'expanded' navbar on  devices under 600px
    };
  }

  componentDidMount() {
    if (window.innerWidth <= 600) {
      this.setState({
        hideNavbar: true,
      });
    }

    window.addEventListener("resize", this._handleResize);
  }

  _handleResize = () => {
    setTimeout(() => {
      if (window.innerWidth > 600) {
        this.setState({
          hideNavbar: false,
        });
      } else {
        this.setState({
          hideNavbar: true,
        });
      }
    }, 500);
  };

  render() {
    if (this.props.sidebarActive && !this.state.hideNavbar) {
      return (
        <div className='side-bar background-blue height-100'>
          <div className='toggle-sidebar-icon' onClick={this.props.toggleSidebar}>
            <FiX />
          </div>
          <div>
            <Link to='/'>
              <img src={logo} className='side-bar-logo'></img>
            </Link>
          </div>
          <ListGroup>
            <Link to='/'>
              <ListGroup.Item className='background-blue text-left' as='li'>

                {/* <Image src={home} alt='' className='side-bar-image' /> */}
                <FaHome />
                <span>Home</span>
              </ListGroup.Item>
            </Link>
            <Link to='/ontwerp'>
              <ListGroup.Item className='background-blue text-left' as='li'>
                {/* <Image src={settings} alt='' className='side-bar-image' /> */}
                <BiCabinet />
                <span>Ontwerp</span>
              </ListGroup.Item>
            </Link>
            <Link to='/account'>
              <ListGroup.Item className='background-blue text-left' as='li'>
                {/* <Image src='' alt='' className='side-bar-image' /> */}
                <FaUserCircle />
                <span>Account</span>
              </ListGroup.Item>
            </Link>
          </ListGroup>
        </div>
      );
    } else {
      return (
        <div className='side-bar-icons background-blue height-100'>
          {!this.state.hideNavbar ? (
            <div className='toggle-sidebar-icon active' onClick={this.props.toggleSidebar}>
              <FiMenu />
            </div>
          ) : null}

          <div>
            <Link to='/'>
              <FaHome />
            </Link>
          </div>
          <div>
            <Link to='/ontwerp'>
              <BiCabinet />
            </Link>
          </div>
          <div>
            <Link to='/account'>
              <FaUserCircle />
              {/* <Image src={account} alt='' className='side-bar-image' /> */}
            </Link>
          </div>
        </div>
      );
    }
  }
}
